// @flow
import { httpGet, httpPost } from '~/core/api/helpers/helpers.api';
import url from 'url';

export function getHubOfflineNotificationsStatus(id: string): Promise<Response> {
    const httpUrl = url.format({
        pathname: `sense/${id}/hub-offline-notifications`
    });

    return httpGet(httpUrl);
}

export function setHubOfflineNotificationsStatus(id: string, status: { status: boolean }): Promise<Response> {
    const httpUrl = url.format({
        pathname: `sense/${id}/hub-offline-notifications`
    });

    return httpPost(httpUrl, status);
}



// WEBPACK FOOTER //
// ./src/core/api/products/sense/index.js